import { Component, inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TakeUntilDestroy } from '@app/shared/decorators/take-until-destroy.decorator';
import { Modal, ModalConfig, ModalType, NonPersistedModalName } from '@app/shared/models/modal.model';
import { ShopOffersItem } from '@app/shared/models/shop-offers.model';
import { LoggerService } from '@app/shared/services/logger.service';
import { EventManager } from '@app/shared/utils/event-manager';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { BoxComponent } from '@app/shared/components/liveops/box/box.component';
import { AnimatedTimerComponent } from '@app/shared/components/animated-timer/animated-timer.component';
import { ButtonComponent } from '@app/shared/components/button/button.component';
import { SharedModule } from '@app/shared/shared.module';
import { NavigationButtonComponent } from '@app/shared/components/navigation-button/navigation-button.component';
import { LimitedTimeEvent } from '@app/shared/models/limitedTimeEvent.model';
import { EventsRepository } from '@app/shared/state/events/events.repository';
import { ShopRatesRepository } from '@app/shared/state/shop-rates/shop-rates.repository';

@TakeUntilDestroy
@Component({
  selector: 'slotcom-slotcard-start-modal',
  templateUrl: './slotcard-start.component.html',
  styleUrls: ['./slotcard-start.component.scss'],
  standalone: true,
  imports: [BoxComponent, AnimatedTimerComponent, ButtonComponent, SharedModule, NavigationButtonComponent],
})
export class SlotcardStartModalComponent implements OnInit {
  componentDestroy: () => Observable<unknown>;

  private readonly eventManager = inject(EventManager);
  private readonly eventsRepo = inject(EventsRepository);
  private readonly shopRatesRepo = inject(ShopRatesRepository);
  private readonly translateService = inject(TranslateService);
  public readonly logger = inject(LoggerService);
  protected readonly slotcardStartModalData = inject<ModalConfig>(MAT_DIALOG_DATA);

  event: LimitedTimeEvent;
  lang: string;
  slotcardShopItem: ShopOffersItem;
  slotcardMinPurchase: string;
  slotcardCurrencySymbol: string;

  ngOnInit(): void {
    this.lang = this.translateService.currentLang;
    this.event = this.eventsRepo.getEventById(this.slotcardStartModalData.properties.eventId);

    this.calculateMinPurchase();
  }

  closeModal(): void {
    this.eventManager.closeModal(
      new Modal(this.slotcardStartModalData.id, ModalType.Persisted, this.slotcardStartModalData)
    );
  }

  openSlotcard(): void {
    this.eventManager.openModal(
      new Modal(NonPersistedModalName.SlotcardModalComponent, ModalType.View, this.slotcardStartModalData)
    );
    this.closeModal();
  }

  private calculateMinPurchase(): void {
    this.slotcardShopItem = this.shopRatesRepo
      .getShopRates()
      .Coins?.find((rate) => rate.sku === this.slotcardStartModalData.properties.sku);
    this.slotcardMinPurchase = this.slotcardShopItem ? this.slotcardShopItem.amount : '0';
    this.slotcardCurrencySymbol = this.slotcardShopItem ? this.slotcardShopItem.currencySymbol : '';
  }
}
